import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthLayout } from "@/components/AuthLayout";
import { Button } from "@/components/ui/Button";
import { Field } from "@/components/ui/Field";
import { useAuth } from "@/contexts/AuthContext";

// Réplica de reference/expo-frontend/app/register.tsx.
export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [nickname, setNickname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!name.trim() || !email.trim() || !password) {
      setError("Preencha todos os campos obrigatórios.");
      return;
    }
    setError(null);
    setLoading(true);
    const result = await register(
      name.trim(),
      email.trim(),
      password,
      nickname.trim() || undefined,
    );
    setLoading(false);
    if (result.error) {
      setError(result.error);
    } else {
      navigate("/");
    }
  };

  return (
    <AuthLayout
      title="Criar conta"
      subtitle="Preencha seus dados para participar do bolão."
    >
      <form onSubmit={onSubmit} className="flex flex-col gap-4.5">
        <Field
          label="Nome"
          tone="auth"
          autoComplete="name"
          placeholder="Seu nome completo"
          value={name}
          onChange={(e) => setName(e.target.value)}
          disabled={loading}
        />
        <Field
          label="Apelido (opcional)"
          tone="auth"
          autoComplete="nickname"
          placeholder="Como quer aparecer nos rankings"
          value={nickname}
          onChange={(e) => setNickname(e.target.value)}
          disabled={loading}
        />
        <Field
          label="E-mail"
          tone="auth"
          type="email"
          autoComplete="email"
          placeholder="seu@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={loading}
        />
        <Field
          label="Senha"
          tone="auth"
          type="password"
          autoComplete="new-password"
          placeholder="Mínimo de 6 caracteres"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={loading}
        />

        {error && (
          <p className="rounded-(--radius-field) bg-destructive/15 px-4 py-3 text-sm text-[#ffb4ad]">
            {error}
          </p>
        )}

        <Button
          type="submit"
          title="Criar conta"
          loading={loading}
          className="mt-1"
        />
      </form>

      <div className="mt-6 flex items-center justify-center text-sm">
        <span className="text-surface-alt-foreground/55">Já tem conta? </span>
        <Link to="/login" className="ml-1 font-bold text-accent">
          Entrar
        </Link>
      </div>
    </AuthLayout>
  );
}
